/**
 * Dynamically load OneTrust scripts based on configuration
 * @param {string} configValue - Configuration value from database (format: URL1|URL2|domain-script-id)
 */
export const loadOneTrustScripts = (configValue) => {
    if (!configValue || configValue.trim() === '') {
        console.warn('OneTrust configuration is missing');
        return;
    }

    // Check if OneTrust scripts are already loaded
    const existingScripts = document.querySelectorAll('script[src*="cookielaw.org"]');
    if (existingScripts.length > 0) {
        return;
    }

    // Parse configuration: URL1|URL2|domain-script-id
    let autoBlockUrl, sdkUrl, domainScriptId;

    if (configValue.indexOf('|') > -1) {
        const parts = configValue.split('|');
        autoBlockUrl = parts[0];
        sdkUrl = parts[1];
        domainScriptId = parts[2] || '9810e38c-7df8-45dc-b1da-26c4316b113f-test';
    } else {
        autoBlockUrl = configValue;
        sdkUrl = configValue.replace('OtAutoBlock.js', 'otSDKStub.js');
        domainScriptId = '9810e38c-7df8-45dc-b1da-26c4316b113f-test';
    }

    try {
        // Inject OtAutoBlock.js first
        const autoBlockScript = document.createElement('script');
        autoBlockScript.type = 'text/javascript';
        autoBlockScript.src = autoBlockUrl;
        autoBlockScript.async = true;

        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(autoBlockScript, firstScript);
        } else {
            document.head.appendChild(autoBlockScript);
        }

        // Inject otSDKStub.js with required attributes
        setTimeout(() => {
            const sdkScript = document.createElement('script');
            sdkScript.type = 'text/javascript';
            sdkScript.src = sdkUrl;
            sdkScript.charset = 'UTF-8';
            sdkScript.async = true;
            sdkScript.setAttribute('data-document-language', 'true');
            sdkScript.setAttribute('data-domain-script', domainScriptId);

            if (firstScript && firstScript.parentNode) {
                firstScript.parentNode.insertBefore(sdkScript, firstScript);
            } else {
                document.head.appendChild(sdkScript);
            }
        }, 100);
    } catch (error) {
        console.error('Failed to load OneTrust scripts');
    }
};

/**
 * Initialize OneTrust OptanonWrapper function
 */
export const initializeOptanonWrapper = () => {
    if (!window.OptanonWrapper) {
        window.OptanonWrapper = function () {};
    }
};
